import React from "react";


export interface People {
    id: string;
    href?: string;
    name: string;
    job: string;
    avatar: string;


}

const FOUNDER_DEMO: People[] = [
    {
        id: "1",
        href: "https://www.linkedin.com/in/daniel-james-kramer/",
        name: `Dan Kramer`,
        job: "Product Manager & Front-End Engineer",
        avatar:
            "https://i.ibb.co/FsGM9yp/1642187900079.png",
    },
    {
        id: "4",
        name: `Furqan Khan`,
        job: "Back-End Software Engineer",
        avatar:
            "https://i.ibb.co/WttqQWH/image.png",
        href: "https://www.linkedin.com/in/frk14/",
    },
    {
        id: "3",
        name: `Lewis Dickinson`,
        job: "Business Development",
        avatar:
            "https://i.ibb.co/YpkYHq4/image.png",
        href: "https://www.linkedin.com/in/lewis-dickinson-5029021b5/",
    },
    {
        id: "2",
        name: `Ali Hassan`,
        job: "Support Assistant",
        avatar:
            "https://i.ibb.co/mBWXTLk/image.png",
        href: "https://www.linkedin.com/in/mirza-ali-hassan/",
    },


];

const SectionFounder = () => {
    return (
        <div className=" text-center justify-center SectionFounder ">
            <div className="text-center justify-center grid sm:grid-cols-2 gap-x-5 gap-y-8 lg:grid-cols-4 xl:gap-x-8">
                {FOUNDER_DEMO.map((item) => (
                    <div key={item.id} className="max-w-sm">
                        <a href={item.href} target="_blank" rel="noreferrer">
                            <img
                                src={item.avatar}
                                alt="Visionaries"
                            />
                        </a>
                        <a href={item.href} target="_blank" rel="noreferrer">
                            <h3 className="text-center justify-center text-lg font-semibold text-neutral-900 mt-4 md:text-xl dark:text-neutral-200">
                                {item.name}
                            </h3>
                        </a>
                        <a href={item.href} target="_blank" rel="noreferrer">
                            <span
                                className="text-center justify-center block text-sm text-neutral-500 sm:text-base dark:text-neutral-400">
                            {item.job}
                        </span>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SectionFounder;
